import React from 'react'
import { FormattedMessage } from 'react-intl'

const VersionNavigator = ({
  history,
  activeVersionNum,
  setActiveVersionNum,
}) => {
  const versionsCount = history.size
  return (
    <div className="flexbox padding-normal">
      <div className="flexbox-grow flexbox flexbox-column flexbox-centered">
        <div className="bold margin-bottom-smaller">Version history</div>
        <div className="font-size-small shade-20 bold">
          <FormattedMessage
            id="noteHistory.versionsCount"
            defaultMessage={`{versionsCount, plural,
              =0 {Empty}
              one {1 version}
              other {# versions}
            }`}
            values={{ versionsCount }}
          />
        </div>
      </div>
    </div>
  )
}

export default VersionNavigator
